import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { GenericRESTPagedClientManager } from "../../../../js/lib/manager/GenericRESTPagedClientManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { LS2PAC_Utils } from "../utils/Utils";

// used by LS2Kids
export class SearchClientManager extends GenericRESTPagedClientManager {
  constructor(options) {
    super($.extend({ searchEvent: LS2PAC_CONSTANTS.Events.onSearch }, options));

    this.searchDatabaseManager = options.searchDatabaseManager;
    this.restOptions.cancellable = true;
    this.extraDataToPassBack = options.databaseConfig;
    TLCLogger.log("extraDataToPassBack", this.extraDataToPassBack);
    this.defaultSortKey = options.databaseConfig.sortingData.sortKey;
    this.sortingData = options.databaseConfig.sortingData;
    this.searchTermInfo = {};
    this.facetFilters = [];
    this.branchFilters = null;
    this.audience = [];
    this.addListeners();
  }
  fireSearch(event) {
    if (this.isCurrent()) {
      this.validateSortType();

      var searchParams = this.getSearchParams();

      if (event.searchParams) {
        searchParams = event.searchParams;
      }
      TLCLogger.log("searchClient:fireSearch", searchParams, this.restOptions);
      this.search(searchParams);
    }
  }
  getSearchSpellingSuggestions(response) {
    var searchParams = this.getSearchParams();

    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.getSpellingSuggestions, {
      postData: searchParams,
      callback: function (data) {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onGetSpellingSuggestionsResponse,
          {
            success: true,
            suggestions: data,
            term: searchParams.searchTerm,
          }
        );
      },
      error: function () {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onGetSpellingSuggestionsResponse,
          {
            success: false,
            term: searchParams.searchTerm,
          }
        );
      },
    });
  }
  validateSortType() {
    var found = false;

    if (this.sortingData && this.sortingData.sortOptions) {
      for (
        var i = 0, length = this.sortingData.sortOptions.length;
        i < length;
        i++
      ) {
        if (this.sortingData.sortOptions[i].value == this.sortingData.sortKey) {
          found = true;
          break;
        }
      }
    }

    if (!found && this.defaultSortKey) {
      this.sortingData.sortKey = this.defaultSortKey;
    }
  }
  getSearchParams() {
    return {
      searchTerm: LS2PAC_Utils.getQualifiedSearchTerm(
        this.searchTermInfo.value,
        this.searchTermInfo.type
      ),
      startIndex: this.currentPage * this.pageSize,
      hitsPerPage: this.pageSize,
      facetFilters: this.facetFilters,
      branchFilters: this.getBranchFilters(),
      sortCriteria: this.sortingData.sortKey,
      targetAudience: this.extraDataToPassBack.targetAudience,
      dbCodes: [],
      searchedFromKids: this.extraDataToPassBack.searchedFromKids,
    };
  }
  getResourceById(id) {
    for (var i = 0, len = this.pages.length; i < len; i += 1) {
      if (!this.pages[i]) {
        continue;
      }
      for (var a = 0, aLen = this.pages[i].resources.length; a < aLen; a += 1) {
        if (this.pages[i].resources[a].id == id) {
          return this.pages[i].resources[a];
        }
      }
    }

    return null;
  }
  getSearchCount() {
    var _this = this,
      success = false,
      response = {};

    function respondWithNoResults() {
      success = true;
      response.success = true;
      response.totalHits = 0;
      response.results = [];

      TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGetDatabaseSearchCount, {
        success: success,
        data: response,
        databaseKey: _this.extraDataToPassBack.databaseKey,
      });
    }

    setTimeout(function () {
      var searchParams = _this.getSearchParams();

      //LS2PAC database (advanced search) is the only one that takes an object as the search term
      // - if this happens, return 0 hits
      if (
        _this.extraDataToPassBack.databaseKey !=
          LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key &&
        LS2PAC_Utils.isSearchTermAnObject(searchParams.searchTerm)
      ) {
        respondWithNoResults();

        //If no search term but search term is require
      } else if (
        _this.extraDataToPassBack.requiresSearchTerm &&
        (!searchParams.searchTerm || searchParams.searchTerm.length == 0)
      ) {
        respondWithNoResults();
      } else {
        const {searchTerm} = searchParams;
        const postData = {...searchParams, searchTerm: typeof searchTerm === "object" ? JSON.stringify(searchTerm) : searchTerm};
        TLCRest.jsonCall(_this.restUrl + "/count", {
          postData,
          callback: function (data) {
            response = data;
            success = true;
          },
          finallyHandler: function () {
            TLCEvents.trigger(
              LS2PAC_CONSTANTS.Events.onGetDatabaseSearchCount,
              {
                success: success,
                data: response,
                databaseKey: _this.extraDataToPassBack.databaseKey,
              }
            );
          },
        });
      }
    }, 3000);
  }
  resetPageCache(clearFacets) {
    this.pages = [];
    this.hasResults = false;
    this.totalHits = 0;
    this.currentPage = 0;
    this.sortingData.sortKey = this.defaultSortKey;
    this.branchFilters = null;

    if (clearFacets) {
      this.facetFilters = [];
    }
  }
  getURLParamsForHash(event) {
    const params = new URLSearchParams();
    const {searchParams, readingLevelFilters} = event;
    const {searchTerm} = event.searchParams;
    params.set("section", this.searchEvent);
    params.set("term", searchTerm);
    params.set("page", this.currentPage);
    params.set("sortKey", this.sortingData.sortKey);
    params.set("db", this.extraDataToPassBack.databaseKey);
    params.set("branchFilters", JSON.stringify(this.getBranchFilters()));
    params.set("facetFilters", JSON.stringify(event.facetFilters || this.facetFilters));

    if (
      event.searchParams.audienceCharacteristicsFilters &&
      ApplicationData.locationConfiguration.showAudienceControl()
    ) {
      params.set("audience", JSON.stringify(this.audience));
    }

    if (event.viewName) {
      params.set("view", event.viewName);
    }

    const arFilters = readingLevelFilters || searchParams.readingLevelFilters;
    if(arFilters){
      params.set("readingLevelFilters",  JSON.stringify(arFilters, (key, value) => {
        // Exclude properties with null values
        return value === null ? undefined : value;
      }));
    }

    return params.toString();
  }
  isCurrent() {
    return this.searchDatabaseManager.isCurrentDatabase(
      this.extraDataToPassBack.databaseKey
    );
  }
  getBranchFilters() {
    return ApplicationData.branchLimitsUtil.getLimitedBranches();
  }
  specialDataHandling(data) {
    if (data.results) {
      data.resources = data.results;
    }
  }
  onBeforeFireSearch(event) {
    this.getSearchCount();
    if (this.isCurrent() == false) {
      return;
    }
    this.fireSearch(event);
  }
  addListeners() {
    var _this = this;

    TLCEvents.on(this.searchEvent, function (event) {
      //do some pre-processing on the data
      if (event.searchString) {
        _this.searchTermInfo = {
          value: event.searchString,
          type: event.searchType || "default",
        };
      }

      _this.onBeforeFireSearch(event);
    });

    TLCEvents.on(this.responseEvent, function (event) {
      if (event.success && _this.isCurrent()) {
        _this.hasResults = true;
      }
    });

    TLCEvents.on(LS2PAC_CONSTANTS.Events.onLoginResponse, function (event) {
      if (event.success) {
        if (_this.searchTermInfo && _this.searchTermInfo.value != undefined) {
          if (_this.searchTermInfo.value.length > 0) {
            _this.getSearchCount();
          }
        }
      }
    });

    TLCEvents.on(
      LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase,
      function (event) {
        if (_this.isCurrent()) {
          //				if( !_this.extraDataToPassBack.requiresSearchTerm || (_this.searchTermInfo && _this.searchTermInfo.value != "" && _this.searchTermInfo.value.length > 0) ) {
          _this.fireSearch(event);
          _this.addHistory(event);
          //				}
        }
      }
    );

    TLCEvents.on(LS2PAC_CONSTANTS.Events.onSortSearch, function (event) {
      if (_this.isCurrent()) {
        _this.resetPageCache(false);
        _this.sortingData.sortKey = event.sortKey;
        _this.fireSearch(event);
        _this.addHistory(event);
      }
    });

    TLCEvents.on(LS2PAC_CONSTANTS.Events.onLogoutResponse, function (event) {
      _this.resetPageCache(true);
    });

    TLCEvents.on(LS2PAC_CONSTANTS.Events.onHome, function (event) {
      _this.resetPageCache(true);
    });
  }
}
